<template>
  <o-table :title="$t('core.users')" url="/api/system/users" ref="tableList" :custom-row-button="true">
    <template slot="head">
      <o-table-header column="name">{{$t('core.name')}}</o-table-header>
      <o-table-header column="email">{{$t('core.email')}}</o-table-header>
      <o-table-header column="phone">{{$t('core.phone')}}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.name }}</td>
      <td>{{ props.item.email }}
        <span class="badge badge-info" v-if="props.item.is_super_user">{{$t('core.super_user')}}</span>
      </td>
      <td>{{ props.item.phone }}</td>
    </template>
    <template slot="body-controls" slot-scope="props">
      <td class="text-right">
        <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
          <b-btn variant="secondary" v-if="user.id !== props.item.id" @click="impersonateUser(props.item)">
            <fa icon="sign-in-alt"/>
          </b-btn>
          <o-delete method="delete" :url="$refs.tableList.deleteUrl() + '/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
          <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
            <fa icon="pencil-alt"/>
          </router-link>
        </div>
      </td>
    </template>
  </o-table>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  methods: {
    impersonateUser (user) {
      axios.post(`/api/system/users/${user.id}/impersonate`).then((response) => {
        if (!response.data) {
          return
        }

        this.$store.dispatch('auth/saveOriginalToken', {
          originalToken: this.$store.getters['auth/token'],
          remember: false
        })

        this.$store.dispatch('auth/saveToken', {
          token: response.data,
          remember: false
        })

        this.$store.dispatch('auth/fetchUser')

        const homePage = this.$router.resolve({ name: 'home' })
        window.location.href = homePage.href

      }).catch((error) => {
        window.alert('Something went wrong, do you have the permission to impersonate?')
      })
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  }
}
</script>
